import { Pipe, PipeTransform } from '@angular/core';
import { FacetValueOfString } from 'src/business/services/client.generated';

@Pipe({
  name: 'someSelected',
  standalone: true
})
export class SomeSelectedPipe implements PipeTransform {

  transform(value: FacetValueOfString[]): '' | null {
    return (value??[])?.some(val => val.selected) ? '' : null;
  }

}
